import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CustomInputComponent } from 'components/input/custom-input/custom-input.component';
import { CustomSelectComponent } from 'components/input/custom-select/custom-select.component';
import { DataRowComponent, DataTableComponent } from 'components/layout/data-table/data-table.component';
import { InputType } from 'enums/InputType';
import { FreeProductPlanSettingDtoModel } from 'models/generated/Models.FreeProductPlanSettingDto';
import { SelectListItemModel } from 'models/SelectList';
import { TranslatePipe } from 'pipes/translate.pipe';

@Component({
	selector: 'free-product-plan-setting',
	templateUrl: './free-product-plan-setting.component.html',
	imports: [DataTableComponent, DataRowComponent, CustomSelectComponent, CustomInputComponent, TranslatePipe]
})
export class FreeProductPlanSettingComponent {

	@Input() setting!: FreeProductPlanSettingDtoModel;
	@Input('tags') selectListTags: SelectListItemModel[] = [];
	@Output() settingChange = new EventEmitter<FreeProductPlanSettingDtoModel>();

	inputTypeEnum = InputType;

	valueChange() {
		this.settingChange.emit(this.setting);
	}
}
